import { CrossReferencesOpinionOption } from '../../../../../../../../../frontend/libs/shared/src/lib/types/product/crossess-refernces';
import { from } from 'rxjs';
import { CrossOpinionEnum } from '../../../../../../../../../frontend/libs/shared/src/lib/types/contract/contract-product-cross-reference.enums';

export default class AptAssessmentVote {
  static findProductByCrossReferenceId(products, crossReferenceId) {
    return products.find((product) => {
      if (!product.crosses) {
        return false;
      } else {
        return product.crosses.find((cross) => {
          return crossReferenceId === cross.crossReferenceId;
        });
      }
    });
  }

  static findCross(product, crossReferenceId) {
    return product.crosses.find((cross) => {
      return crossReferenceId === cross.crossReferenceId;
    });
  }

  static currentOpinion(
    targetProductCrossApproveCount,
    targetProductCrossDisputeCount,
    targetProductCrossCrossApproveCount,
    targetProductCrossCrossDisputeCount,
    targetProductCrossNotes,
    targetProductCrossCrossOpinion,
    targetProductCrossParentOpinion,
    vote,
    accountEmail,
    crossReferenceOpinionOption?: CrossReferencesOpinionOption,
    fromDropdown?: boolean,
  ) {
    targetProductCrossNotes = targetProductCrossNotes.slice(0);
    if (vote === 'approve') {
      switch (targetProductCrossCrossOpinion) {
        case 'approve':
          if (fromDropdown) {
            targetProductCrossNotes.push({
              note: crossReferenceOpinionOption.feedbackDescription,
              createdDate: new Date(),
              createdBy: accountEmail,
            });
          } else {
            targetProductCrossCrossOpinion = 'no_opinion';
            if (!targetProductCrossParentOpinion) {
              targetProductCrossApproveCount -= 1;
              targetProductCrossCrossApproveCount -= 1;
            } else {
              targetProductCrossApproveCount -= 1;
              targetProductCrossParentOpinion = false;
            }
            targetProductCrossNotes.push({
              note:
                crossReferenceOpinionOption?.feedbackDescription ||
                'Approval Removed',
              createdDate: new Date(),
              createdBy: accountEmail,
            });
          }
          break;
        case 'dispute':
          targetProductCrossCrossOpinion = 'approve';
          if (!targetProductCrossParentOpinion) {
            targetProductCrossApproveCount += 1;
            targetProductCrossDisputeCount -= 1;
            targetProductCrossCrossApproveCount += 1;
            targetProductCrossCrossDisputeCount -= 1;
          } else {
            targetProductCrossApproveCount += 1;
            targetProductCrossCrossApproveCount += 1;
            targetProductCrossDisputeCount -= 1;
            targetProductCrossParentOpinion = false;
          }
          targetProductCrossNotes.push({
            note:
              crossReferenceOpinionOption?.feedbackDescription ||
              'Cross Approved',
            createdDate: new Date(),
            createdBy: accountEmail,
          });
          break;
        case 'no_opinion':
        default:
          targetProductCrossCrossOpinion = 'approve';
          targetProductCrossApproveCount += 1;
          targetProductCrossCrossApproveCount += 1;
          targetProductCrossNotes.push({
            note:
              crossReferenceOpinionOption?.feedbackDescription ||
              'Cross Approved',
            createdDate: new Date(),
            createdBy: accountEmail,
          });
          break;
      }
    } else if (vote === 'dispute') {
      switch (targetProductCrossCrossOpinion) {
        case 'dispute':
          if (fromDropdown) {
            targetProductCrossNotes.push({
              note: crossReferenceOpinionOption.feedbackDescription,
              createdDate: new Date(),
              createdBy: accountEmail,
            });
          } else {
            targetProductCrossCrossOpinion = 'no_opinion';
            if (!targetProductCrossParentOpinion) {
              targetProductCrossDisputeCount -= 1;
              targetProductCrossCrossDisputeCount -= 1;
            } else {
              targetProductCrossDisputeCount -= 1;
              targetProductCrossParentOpinion = false;
            }
            targetProductCrossNotes.push({
              note:
                crossReferenceOpinionOption?.feedbackDescription ||
                'Dispute Removed',
              createdDate: new Date(),
              createdBy: accountEmail,
            });
          }
          break;
        case 'approve':
          targetProductCrossCrossOpinion = 'dispute';
          if (!targetProductCrossParentOpinion) {
            targetProductCrossDisputeCount += 1;
            targetProductCrossApproveCount -= 1;
            targetProductCrossCrossDisputeCount += 1;
            targetProductCrossCrossApproveCount -= 1;
          } else {
            targetProductCrossDisputeCount += 1;
            targetProductCrossCrossDisputeCount += 1;
            targetProductCrossApproveCount -= 1;
            targetProductCrossParentOpinion = false;
          }
          targetProductCrossNotes.push({
            note:
              crossReferenceOpinionOption?.feedbackDescription ||
              'Cross Disputed',
            createdDate: new Date(),
            createdBy: accountEmail,
          });
          break;
        case 'no_opinion':
        default:
          targetProductCrossCrossOpinion = 'dispute';
          targetProductCrossDisputeCount += 1;
          targetProductCrossCrossDisputeCount += 1;
          targetProductCrossNotes.push({
            note:
              crossReferenceOpinionOption?.feedbackDescription ||
              'Cross Disputed',
            createdDate: new Date(),
            createdBy: accountEmail,
          });
          break;
      }
    } else if (vote === 'review') {
      switch (targetProductCrossCrossOpinion) {
        case 'dispute':
          targetProductCrossCrossOpinion = 'review';
          if (!targetProductCrossParentOpinion) {
            targetProductCrossDisputeCount -= 1;
            targetProductCrossCrossDisputeCount -= 1;
          } else {
            targetProductCrossDisputeCount -= 1;
            targetProductCrossParentOpinion = false;
          }
          targetProductCrossNotes.push({
            note: crossReferenceOpinionOption?.feedbackDescription,
            createdDate: new Date(),
            createdBy: accountEmail,
          });
          break;
        case 'approve':
          targetProductCrossCrossOpinion = 'review';
          if (!targetProductCrossParentOpinion) {
            targetProductCrossApproveCount -= 1;
            targetProductCrossCrossApproveCount -= 1;
          } else {
            targetProductCrossApproveCount -= 1;
            targetProductCrossParentOpinion = false;
          }
          targetProductCrossNotes.push({
            note: crossReferenceOpinionOption?.feedbackDescription,
            createdDate: new Date(),
            createdBy: accountEmail,
          });
          break;
        case 'no_opinion':
        default:
          targetProductCrossCrossOpinion = 'review';
          targetProductCrossNotes.push({
            note: crossReferenceOpinionOption?.feedbackDescription,
            createdDate: new Date(),
            createdBy: accountEmail,
          });
          break;
      }
    } else if (vote === CrossOpinionEnum.NO_OPINION) {
      switch (targetProductCrossCrossOpinion) {
        case 'dispute':
          targetProductCrossCrossOpinion = CrossOpinionEnum.NO_OPINION;
          if (!targetProductCrossParentOpinion) {
            targetProductCrossDisputeCount -= 1;
            targetProductCrossCrossDisputeCount -= 1;
          } else {
            targetProductCrossDisputeCount -= 1;
            targetProductCrossParentOpinion = false;
          }
          targetProductCrossNotes.push({
            note: crossReferenceOpinionOption?.feedbackDescription,
            createdDate: new Date(),
            createdBy: accountEmail,
          });
          break;
        case 'approve':
          targetProductCrossCrossOpinion = CrossOpinionEnum.NO_OPINION;
          if (!targetProductCrossParentOpinion) {
            targetProductCrossApproveCount -= 1;
            targetProductCrossCrossApproveCount -= 1;
          } else {
            targetProductCrossApproveCount -= 1;
            targetProductCrossParentOpinion = false;
          }
          targetProductCrossNotes.push({
            note: crossReferenceOpinionOption?.feedbackDescription,
            createdDate: new Date(),
            createdBy: accountEmail,
          });
          break;
        case 'no_opinion':
        default:
          targetProductCrossCrossOpinion = CrossOpinionEnum.NO_OPINION;
          targetProductCrossNotes.push({
            note: crossReferenceOpinionOption?.feedbackDescription,
            createdDate: new Date(),
            createdBy: accountEmail,
          });
          break;
      }
    }

    targetProductCrossParentOpinion = false;
    return {
      targetProductCrossCrossOpinion,
      vote,
      targetProductCrossNotes,
      targetProductCrossCrossApproveCount,
      targetProductCrossCrossDisputeCount,
      targetProductCrossParentOpinion,
      targetProductCrossApproveCount,
      targetProductCrossDisputeCount,
    };
  }
}
